import ErrorPageContainer from './ErrorPageContainer';

export default ErrorPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ErrorPage/index.js